export default __webpack_public_path__ + "static/media/DOC_SPOT.b51a80d1.png";